import PropTypes from "prop-types";

/**
 *
 * @param {string} width
 * @param {string} height
 * @param {string} fill
 * @param {string} pathFill
 * @returns {JSX.Element}
 * @constructor
 */
export default function Close({ height = '23', width = '24', fill = 'none', pathFill = 'black' }) {
    return (
        <svg width={width} height={height} viewBox="0 0 24 23" fill={fill} xmlns="http://www.w3.org/2000/svg">
            <path d="M6.53516 5.65686L17.8492 16.9703" stroke={pathFill} stroke-width="2"/>
            <path d="M6.53516 16.9707L17.8486 5.65669" stroke={pathFill} stroke-width="2"/>
        </svg>
    );
}

Close.PropTypes = {
    width: PropTypes.string,
    height: PropTypes.string,
    fill: PropTypes.string,
    pathFill: PropTypes.string,
}
